// extracted by mini-css-extract-plugin
module.exports = {"body":"Drawer_body__AuDg_"};